// extracted by mini-css-extract-plugin
module.exports = {"heroBanner":"HomeBanner_heroBanner__3zXDp","mobile":"HomeBanner_mobile__OMb10","desktop":"HomeBanner_desktop__9JDm_"};